import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
/** Элемент навигационного меню. */
let PitNavigationMenuItem = class PitNavigationMenuItem {
    /** Элемент навигационного меню. */
    constructor() {
        this._id = 0;
        this._ownerId = 0;
        this._ord = 0;
        this._hasSubMenu = false;
        this._involvedInRouting = true;
    }
    getNodeHint() {
        return this._hint;
    }
    getNodeIcon() {
        return this._icon;
    }
    getNodeId() {
        return this._id;
    }
    getNodeIdent() {
        return this._ident;
    }
    getNodeOrd() {
        return this._ord;
    }
    getNodeParentId() {
        return this._parentId;
    }
    getNodeTitle() {
        return this._title;
    }
    getNodeRoute() {
        return this._route;
    }
    hasSubTree() {
        return this._hasSubMenu;
    }
    isInvolvedInRouting() {
        return this._involvedInRouting;
    }
    get id() {
        return this._id;
    }
    set id(value) {
        this._id = value;
    }
    get parentId() {
        return this._parentId;
    }
    set parentId(value) {
        this._parentId = value;
    }
    get ownerId() {
        return this._ownerId;
    }
    set ownerId(value) {
        this._ownerId = value;
    }
    get ord() {
        return this._ord;
    }
    set ord(value) {
        this._ord = value;
    }
    get title() {
        return this._title;
    }
    set title(value) {
        this._title = value;
    }
    get ident() {
        return this._ident;
    }
    set ident(value) {
        this._ident = value;
    }
    get icon() {
        return this._icon;
    }
    set icon(value) {
        this._icon = value;
    }
    get hint() {
        return this._hint;
    }
    set hint(value) {
        this._hint = value;
    }
    get hasSubMenu() {
        return this._hasSubMenu;
    }
    set hasSubMenu(value) {
        this._hasSubMenu = value;
    }
    get route() {
        return this._route;
    }
    set route(value) {
        this._route = value;
    }
    get involvedInRouting() {
        return this._involvedInRouting;
    }
    set involvedInRouting(value) {
        this._involvedInRouting = value;
    }
};
tslib_1.__decorate([
    jsonMember({ name: "id", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNavigationMenuItem.prototype, "_id", void 0);
tslib_1.__decorate([
    jsonMember({ name: "parentId", constructor: Number, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNavigationMenuItem.prototype, "_parentId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ownerId", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNavigationMenuItem.prototype, "_ownerId", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ord", constructor: Number, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Number)
], PitNavigationMenuItem.prototype, "_ord", void 0);
tslib_1.__decorate([
    jsonMember({ name: "title", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNavigationMenuItem.prototype, "_title", void 0);
tslib_1.__decorate([
    jsonMember({ name: "ident", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNavigationMenuItem.prototype, "_ident", void 0);
tslib_1.__decorate([
    jsonMember({ name: "icon", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNavigationMenuItem.prototype, "_icon", void 0);
tslib_1.__decorate([
    jsonMember({ name: "hint", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNavigationMenuItem.prototype, "_hint", void 0);
tslib_1.__decorate([
    jsonMember({ name: "hasSubMenu", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitNavigationMenuItem.prototype, "_hasSubMenu", void 0);
tslib_1.__decorate([
    jsonMember({ name: "route", constructor: String, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], PitNavigationMenuItem.prototype, "_route", void 0);
tslib_1.__decorate([
    jsonMember({ name: "involvedInRouting", constructor: Boolean, emitDefaultValue: true, isRequired: false }),
    tslib_1.__metadata("design:type", Boolean)
], PitNavigationMenuItem.prototype, "_involvedInRouting", void 0);
PitNavigationMenuItem = tslib_1.__decorate([
    jsonObject
], PitNavigationMenuItem);
export { PitNavigationMenuItem };
